import { configureStore } from "@reduxjs/toolkit";
import fetchReducer from "./Api/fetch_slice";
import emailTemplateReducer from "../Modules/Email/template_slice";
import configurationReducer from "../Modules/Email/configuration_slice";
import inquiryReducer from "../Modules/Inquiry/inquiry_slice";
import appConfigReducer from "../Modules/AppConfig/app_config_slice";
import tourReducer from "../Modules/ScheduledEvents/tour_slice";
import contarctReducer from "../Modules/Contract/contract_slice";
import layoutReducer from "../Modules/layout_slice";
import FeedbackReducer from "../Modules/Feedback/Feedbackslice";
import RingCentralReducer from "../Modules/Dashboard/RingCentral/RingCentralSlice";
import CustomerStatisficationReducer from "../Modules/Dashboard/CustomerStatisfation/CustomerStatisficationSlice";
import RevenueReducer from "../Modules/Dashboard/Revenue/RevenueSlice";
import CountonLeadReducer from "../Modules/Dashboard/CountsOnLead/CountonLeadSlice";
import ReportReducer from "../Modules/Reports/ReportSlice";
import SalesReducer from "../Modules/Dashboard/Sales/SalesSlice";
import ExecutionReducer from "../Modules/Dashboard/Execution/Executionslice";
import AboutReducer from "../Modules/AboutUS/AboutusSlice";
import WelcomeSectionReducer from "../Modules/WelcomeSection/WelcomeSectionSlice";
import TestimonialsReducer from "../Modules/Testimonials/Testimonial_slice";
import ServicesReducer from "../Modules/Services/ServicesSlice";
import VendorServicesReducer from "../Modules/VendorServices/VendorServiceSlice"
import AmenitiesReducer from "../Modules/Amenities/AmenitiesSlice";
import VenueHighlightsReducer from "../Modules/VenueHighlights/VenueHighlightsSlice";
import { VendorServices } from "../Modules/VendorServices/VendorServices";

export const store = configureStore({
  reducer: {
    fetch: fetchReducer,
    emailTemplate: emailTemplateReducer,
    configuration: configurationReducer,
    inquiry: inquiryReducer,
    appConfig: appConfigReducer,
    tour: tourReducer,
    contract: contarctReducer,
    layout: layoutReducer,
    revenue: RevenueReducer,
    countonLead: CountonLeadReducer,
    feedback: FeedbackReducer,
    ringcentral: RingCentralReducer,
    reviews: CustomerStatisficationReducer,
    reportData: ReportReducer,
    sales: SalesReducer,
    execution: ExecutionReducer,
    aboutUS: AboutReducer,
    reportData: ReportReducer,
    sales: SalesReducer,
    execution: ExecutionReducer,
    WelcomeSection: WelcomeSectionReducer,
    Testimonials: TestimonialsReducer,
    Services: ServicesReducer,
    VendorServices: VendorServicesReducer,
    Amenities: AmenitiesReducer,
    VenueHighlights: VenueHighlightsReducer,

  },
});
